import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/DhLogin";
import Home from "@/views/dhome/DHome";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/login",
      component: Login
    },
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/home",
      component: Home
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js